import React from 'react';
import PropTypes from 'prop-types';

function LastUpdated({ array }) {
  const sorted = array.sort(
    (a, b) => new Date(b.modified_at) - new Date(a.modified_at)
  );
  let lastDate = new Date();
  if (sorted[0]) {
    lastDate = new Date(sorted[0].modified_at);
  }
  const localeOptions = { year: 'numeric', month: 'long', day: 'numeric' };

  return (
    <div className='mb-7 text-base'>
      Last updated:{' '}
      <time dateTime={lastDate.toISOString()}>
        {lastDate.toLocaleString('en-US', localeOptions)}
      </time>
    </div>
  );
}

LastUpdated.propTypes = {
  array: PropTypes.arrayOf(
    PropTypes.shape({
      modified_at: PropTypes.string,
    })
  ),
};

export default LastUpdated;
